jQuery( document ).ready(function( $ ) {

   // ===================================================
   // == Menu Scripts
   //====================================================

   // Menu Initialization (Smart Menu)
   $(function() {
      $('#menu-main-menu').smartmenus(
         {
            subMenusSubOffsetX: 1,
            subMenusSubOffsetY: 0,
            mainMenuSubOffsetX: -9,
            mainMenuSubOffsetY: 18,
            watchOverflow: true,
            collapsibleShowFunction: function($ul, complete) { $ul.fadeIn(250, complete); },
            collapsibleHideFunction: function($ul, complete) { $ul.fadeOut(250, complete); },
            subMenusMinWidth: 'max-conent'
         }
      );
   });

   // Use JS to initialize the transparent header;
   // that way, if JS is disabled, the menu will always appear blue
   const    styledBanner = $('.page-banner'),
            bannerAttr = styledBanner.attr('style');

   if( $('body.single-post')[0] || ( typeof bannerAttr !== 'undefined' && bannerAttr !== false ) ) {

      // blog post menu styling
      if ( $('body.single-post')[0] ) {
         $('#menu-group').addClass("transparent");
         $('#branding').addClass("light");
      }

      // styling for pages with page banners
      if ( typeof bannerAttr !== 'undefined' && bannerAttr !== false ) {
         var  bannerClass = $('.page-banner[class*="lightTxt"]');

         // take background color from page banner and apply it to menu element
         $('#menu-group').attr('style', bannerAttr);

         // if banner has light text, make logo reverse
         // if banner has dark text, use the dark-text version of the logo
         if ( bannerClass.length && $('#branding.light').length ) {
            $('#branding').removeClass("light");
         } else if ( $('.page-banner[class*="darkTxt"]').length ) {
            $('#branding').addClass("light");
            $('#menu-group').addClass("transparent");
         }
      }
   }

   // SmartMenus mobile menu toggle button
   $(function() {
      var      $mainMenuState = $('#main-menu-state');

      const    styledBanner = $('.page-banner'),
               bannerAttr = styledBanner.attr('style');

      if ($mainMenuState.length) {
         // animate mobile menu
         $mainMenuState.change(function(e) {
            var $menu = $('#main-menu-all');
            if (this.checked) {
               $menu.hide().fadeIn(250, function() { $menu.css('display', ''); });

               // add class to prevent scrolling outside of the menu
               $('body').addClass('no-scroll');

               // if menu is set to transparent,
               // remove menu class and logo class
               if( $('#menu-group.transparent')[0] ) {
                  $('#menu-group').removeClass("transparent");
                  $('#branding').removeClass("light");
               }

               // if page has a banner with a style attribute, add the override class
               // to style the site header to match the open menu
               if( typeof bannerAttr !== 'undefined' && bannerAttr !== false  ) {
                  $('.site-header-content').addClass("override");
               }

            } else {
               $menu.show().fadeOut(250, function() { $menu.css('display', ''); });

               // if body is set to no-scroll, remove class to add scrolling back
               if( $('body.no-scroll')[0] ) {
                  $('body').removeClass('no-scroll');
               }

               // remove default styling override
               if( $('.site-header-content[class*="override"]') ) {
                  $('.site-header-content').removeClass("override");
               }

               // Add light color class back to menu for blog posts and pages with light-bg banners
               if( $('body.single-post')[0] || $('.page-banner[class*="darkTxt"]').length ) {
                  $('#menu-group').addClass("transparent");
                  $('#branding').addClass("light");
               }
            }
         });
         // hide mobile menu beforeunload
         $(window).bind('beforeunload unload', function() {
            if ($mainMenuState[0].checked) {
               $mainMenuState[0].click();
            }
         });
      }
   });

   $('.site-header nav ul[id="menu-main-menu"]>li>a').click( function() {
      $('body').removeClass('no-scroll');
      //$('#main-menu-all').hide();
      $('#main-menu-state').prop('checked', false);
   });

   //Function to hide menu toggle from Aria controls on desktop, and to make it keyboard functional on mobile
   function checkSize(){
      if ( $('.main-menu-btn').css('top') == '-99999px' ){
         // remove tab functionality on the Menu Toggle on desktop
         $('#main-menu-state').attr('tabindex', '-1');

      } else if ( $('.main-menu-btn').css('top') !== '-99999px' )  {
         // note: this elseif statement seems redundant to 'else', but using 'else' breaks the functionality

         // If tabindex = -1, then set tab index to 0 to make it become tabbable
         if ( $('#main-menu-state').attr('tabindex') == '-1' ) {
            $('#main-menu-state').attr('tabindex', '0');
         }

         // on keypress (enter) of the toggle button, check and uncheck the input
         $('#main-menu-state').on('keypress', function() {
            if ( $('#main-menu-state').is(':checked') ) {
               $('#main-menu-state').prop('checked', false);

            } else {
               $('#main-menu-state').prop('checked', true);

            }
         });

         $(document).on( 'keydown', function(event) {
            if ( $('#main-menu-state').is(':checked') ) {
               if (event.key == "Escape") {
                  $('#main-menu-state').prop('checked', false);
               }
            }
         });
      }
   }
   // run test on initial page load
   checkSize();
   // run test on resize of the window
   $(window).resize(checkSize);


   // ===================================================
   // == Fancybox initialization
   //====================================================

   // $(".fancybox").fancybox({
   //    maxWidth	: 900,
   //    maxHeight	: 800,
   //    fitToView	: false,
   //    width		: '90%',
   //    height		: 'auto',
   //    minHeight: 250,
   //    autoSize	: false
   // });


   // ===================================================
   // == Accordion Initialization
   //====================================================

   // //Initialize Accordions
   // $(function () {
   //    $('.js-accordion').accordion();
   // });


   // ===================================================
   // == Carrousel / Swiper Initialization
   //====================================================

   const thePhotos = document.querySelectorAll('.photo-swiper');
   for( let i = 0; i < thePhotos.length; i++ ) {

      thePhotos[i].classList.add('photo-swiper-' + i);

      const photoSwiper = new Swiper('.photo-swiper-' + i, {
         slidesPerView: 1,
         loop: true,
         centerInsufficientSlides: true,
         autoplay: {
            delay: 5500,
            disableOnInteraction: true,
         },
         navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          runCallbacksOnInit:false,
          on: {
            init: function(swiper){
               $('.swiper-slide').attr('aria-hidden','true');
               $('.swiper-slide-active').attr('aria-hidden','false');
            },
            slideChange: function(swiper){
               var myslide = photoSwiper.activeIndex;

               $('.swiper-slide').attr('aria-hidden','true');

               setTimeout(function(){
                  $('.swiper-slide-active').attr('aria-hidden','false');
                  $("#SwiperLive").text("Slide "+(myslide +1) +" displayed");
               }, 0);
            },
          },
         keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          a11y: {
            containerRoleDescriptionMessage: 'Decorative image slideshow',
            // slideLabelMessage: 'Slide number {{index}}',
            slideRole: 'listitem',
          },
      });

      $('.photo-swiper-' + i ).each( function() {

         photoSwiper.loopDestroy();

         const typeChild = $(this).find('.swiper-slide'),
               typeWrapper = $(this).find('.swiper-wrapper');

         if ( typeChild.length > 1 ) {
            photoSwiper.loopCreate();

               // ===================================================
               // == Play / Pause button for slideshow
               //====================================================
                  var playPauseBtn = $('.swiper-navigation .playpause'),
                     swiperNav = $('.swiper-navigation div[role="button"]'),
                     // player = $('.feature-banner video').get(0),
                     icon = $('.swiper-navigation .playpause .fas');

                     // if ( photoSwiper.autoplay.paused ) {
                     //    console.log('stop');
                     //    playPauseBtn.attr( 'aria-pressed', 'true' );
                     //    icon.addClass('fa-play').removeClass('fa-pause');
                     // }

                  // add swiper id to button for aria labelling
                  if ( swiperNav.length ) {
                     var controlID = swiperNav.attr('aria-controls');
                     playPauseBtn.attr('aria-controls', controlID);
                  }

                  playPauseBtn.click( function(){

                     if ( !photoSwiper.autoplay.running ) {
                        photoSwiper.autoplay.start();
                        playPauseBtn.attr( 'aria-pressed', 'false' );
                        icon.addClass('fa-pause').removeClass('fa-play');
                     } else {
                        photoSwiper.autoplay.stop();
                        playPauseBtn.attr( 'aria-pressed', 'true' );
                        icon.addClass('fa-play').removeClass('fa-pause');
                     }
                  });

         } else {
            photoSwiper.autoplay.stop();

            // If .swiper-wrapper does not have "disabled" class, add it
            if ( !typeWrapper.hasClass("disabled") ) {
               typeWrapper.addClass( "disabled" );
            }
         }
      });
   }


   // ===================================================
   // == Image & Text 50/50 / Swiper Initialization
   //====================================================


   var swiper = new Swiper(".img-txt-swiper", {
      centeredSlides: true,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
         delay: 6000,
      },
    });

    var swiper = new Swiper(".img-swiper", {
      centeredSlides: true,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
         delay: 6000,
      },
    });



   // ===================================================
   // == Insert post content inside anchor tag
   //====================================================

   if ($("body").hasClass("has-posts")) {

      $('#post-list .post').each(function(){

         $(this).click(function() {
            window.location = $(this).find("a").attr("href");
            return false;
            });

      });
   }


   // ===================================================
   // == Parallax Initialization Script
   //====================================================

   // if ( $(".generic.bg")[0] || $(".page-banner.bg")[0] ) {

   //    // variables
   //    const paraContainer = ".section.bg",
   //          paraBG = ".section.bg .para-bg-overlay";

   //    // init controller
   //    const parallaxSection = new ScrollMagic.Controller();

   //    // build tween (animation)
   //    var tween = new TimelineMax ()
   //       .add([
   //          gsap.to( paraBG, 1, {backgroundPosition: "center -200% ", ease: Linear.easeNone})
   //       ]);

   //    // build the scene
   //    new ScrollMagic.Scene({
   //          triggerElement: paraContainer,
   //          duration: 2000
   //       })
   //       .setTween( tween )
   //       .addTo( parallaxSection ); // assign the scene to the controller parallaxSection on line 313
   // }

   // for page banner inline
   // if ( $(".page:not(.home) .page-banner.inline-img:not(.imgAuto):not(.imgContainer):not(.imgSmall):not(.ImgCustom)" )[0] && $('.page-banner img').length ) {

   //    // variables
   //       const paraImgContainer = ".page-banner.inline-img",
   //       paraImg = ".page-banner.inline-img .page-banner-img";

   //    // init controller
   //    const parallaxInlineImg = new ScrollMagic.Controller();

   //    // build tween (animation)
   //    var tween = new TimelineMax ()
   //       .add([
   //          gsap.to( paraImg, 1, {top: "0", ease: Linear.easeNone})
   //       ]);

   //    // build the scene
   //    new ScrollMagic.Scene({
   //          triggerElement: paraImgContainer,
   //          duration: 2000
   //       })
   //       .setTween( tween )
   //       .addTo( parallaxInlineImg); // assign the scene to the controller parallaxSection on line 338
   // }

   //    // for page banner inline
   //    if ( $(".page-id-47 .generic.inline-img")[0] && $('.page-id-47 .generic.inline-img img').length ) {

   //       // variables
   //          const genImgContainer = ".generic.inline-img",
   //          genImg = ".generic.inline-img .generic-img";

   //       // init controller
   //       const genInlineImg = new ScrollMagic.Controller();

   //       // build tween (animation)
   //       var tween = new TimelineMax ()
   //          .add([
   //             gsap.to( genImg, 1, {top: "0", ease: Linear.easeNone})
   //          ]);

   //       // build the scene
   //       new ScrollMagic.Scene({
   //             triggerElement: genImgContainer,
   //             duration: 2000
   //          })
   //          .setTween( tween )
   //          .addTo( genInlineImg); // assign the scene to the controller parallaxSection on line 363
   //    }


   // ===================================================
   // == Two Column Panel grouping (for auto alternating)
   //====================================================

   if ($(".two-col")[0]) {

      // ================================================
      // = Grouping (for auto alternating)
      // ================================================

      $(".two-col").each( function() {
         if ( $(this.parentNode).hasClass('two-col-cluster') ) {
            return;
         } else {
            $(this).nextUntil(":not(.two-col)").andSelf().wrapAll("<section class='two-col-cluster' />");
         }
      });

      // ================================================
      // = To the Top scrolling
      // ================================================

      if ( $('.two-col .innerBlock-nav') ) {

         $('a[data-scrollTop="true"]').click(function() {
            $('html, body').animate(
               { scrollTop: 0 },
               "slow",
               function(){
                  history.pushState("", document.title, window.location.pathname
                  + window.location.search);
               }
            );
            return false;
         });
      }
   }

   // ===================================================
   // == Page Navigation Panel
   //====================================================

   if ($(".icon-nav")[0]) {

      $('.icon-nav a[href*="#"]').each(function() {
         var   href = $(this).attr("href"),
               hrefLength = href.indexOf("#") + 1,
               hash = href.substr(hrefLength),
               fullHash = href.substr( href.indexOf("#") ),
               elmnt = document.getElementById(hash);

         $(this).click(function() {
            event.preventDefault();

            $('html, body').animate({
               scrollTop: $(elmnt).offset().top
             }, "slow", function(){
               window.location.hash = fullHash;
             });
         });
      });

   }


   // ===================================================
   // == Video Controls
   //====================================================

   const    vimeoContainer = $('.video[class*="vidID-"]'),
            fullVideoContainer = $('.video[class*="fullVideo"]'),
            blogPost = $('body[class*="single-post"]');



   if( vimeoContainer.length ) {

      vimeoContainer.each( function () {

         if ( fullVideoContainer.length ) {
            var   playPauseBtn = $(this).find('.controls .playpause'),
                  player = $(this).find("iframe")[0].contentWindow;

            playPauseBtn.click( function(){
               if ( playPauseBtn.attr('aria-pressed') == 'false' ) {
                     player.postMessage('{"method":"pause"}', '*');
                     playPauseBtn.attr( 'aria-pressed', 'true' ).html("Resume background video");

               } else {
                     player.postMessage('{"method":"play"}', '*');
                     playPauseBtn.attr( 'aria-pressed', 'false' ).html("Stop background video");
               }
            });
         }

         const    thumbnail = $(this).find('.video-thumbnail'),
                  container = $(this).find('.video-content-video-iframe'),
                  vidID =  $(this).attr('class').split(' ')[1].substr( 6 );

         var     thumbnailTrigger = function() {
                     container.html('<iframe src="https://player.vimeo.com/video/'+ vidID +'?color=ffd700&title=0&byline=0&portrait=0&autoplay=1" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay" fullscreen picture-in-picture allowfullscreen data-ready="true"></iframe>');
                     thumbnail.remove();

                     if ( fullVideoContainer.length ) {
                        playPauseBtn.remove();
                     }
                  };

         thumbnail.click(thumbnailTrigger);
         thumbnail.keypress(function() {
            if (event.which == 13) thumbnailTrigger();
         });
      });
   }




   // ===================================================
   // == JS No Script (uses scripts to hide text)
   //====================================================

   if ( $('.no-script-hide')[0] ) {
      $('.no-script-hide').each( function() {
         $(this).addClass("visually-hidden");
         $(this).find('a').attr('tabindex', '-1');
      });
   }

   if ( $('.no-script')[0] ) {
      $('.no-script').each( function() {
         $(this).removeClass("no-script");
      });
   }


  // ===================================================
   // == Lazy Load Image Initialization
   //====================================================

   $(function() {
      var lazyloadImages;

      if ("IntersectionObserver" in window) {
        lazyloadImages = document.querySelectorAll(".lazyBG");
        var imageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var image = entry.target;
              image.classList.remove("lazyBG");
              imageObserver.unobserve(image);
            }
          });
        });

        lazyloadImages.forEach(function(image) {
          imageObserver.observe(image);
        });
      } else {
        var lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll(".lazyBG");

        function lazyload () {
          if(lazyloadThrottleTimeout) {
            clearTimeout(lazyloadThrottleTimeout);
          }

          lazyloadThrottleTimeout = setTimeout(function() {
            var scrollTop = window.pageYOffset;
            lazyloadImages.forEach(function(img) {
                if(img.offsetTop < (window.innerHeight + scrollTop)) {
                  img.src = img.dataset.src;
                  img.classList.remove('lazyBG');
                }
            });
            if(lazyloadImages.length == 0) {
              document.removeEventListener("scroll", lazyload);
              window.removeEventListener("resize", lazyload);
              window.removeEventListener("orientationChange", lazyload);
            }
          }, 20);
        }

        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
      }
    })

   // ===================================================
   // == Lazy Load Initialization (jquery.lazy.min.js)
   //====================================================


   // altColItems = document.querySelectorAll('.alt-col-list-item');
   // altColItems.forEach( altColitem => altColitem.classList.add('beforeFade') );
   // windowHeight = window.innerHeight;

   // window.addEventListener( 'scroll', () => {
   //    for (var i = 0; i < altColItems.length; i++) {
   //       var altColitem = altColItems[i];
   //       var positionFromTop = altColItems[i].getBoundingClientRect().top;

   //       if (positionFromTop - windowHeight <= 0) {
   //          altColitem.classList.add('fadeIn');
   //          altColitem.classList.remove('beforeFade');
   //       }
   //    }
   // } );

   // for quotes panel
   const quotesListItems = document.querySelectorAll('.quotes-list-item-media');
   quotesListItems.forEach( altColitem => altColitem.classList.add('beforeFade') );
   let windowHeight = window.innerHeight;

   window.addEventListener( 'scroll', () => {
      for (var i = 0; i < quotesListItems.length; i++) {
         var quotesListItem = quotesListItems[i];
         var positionFromTop = quotesListItems[i].getBoundingClientRect().top;

         if (positionFromTop - windowHeight <= 0) {
            quotesListItem.classList.add('fadeIn');
            quotesListItem.classList.remove('beforeFade');
         }
      }
   } );

 // ===================================================
   // == Content Carrousel / Swiper Initialization
   //====================================================
   // This right here
   const theContent = document.querySelectorAll('.content-swiper');
   for( let i = 0; i < theContent.length; i++ ) {

      theContent[i].classList.add('content-swiper-' + i);

      const contentSwiper = new Swiper('.content-swiper-' + i, {
         initialSlide: 3,
         slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
        },
        breakpoints: {
         640: {
           slidesPerView: 1,
           spaceBetween: 30,

         },
         667: {
           slidesPerView: 2,
           spaceBetween: 30,

         },
         1024: {
           slidesPerView: 3,
           spaceBetween: 30,

         },
       },
         navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          runCallbacksOnInit:false,
          on: {
            init: function(swiper){
               $('.swiper-slide').attr('aria-hidden','true');
               $('.swiper-slide-active').attr('aria-hidden','false');
            },
            slideChange: function(swiper){
               var myslide = contentSwiper.activeIndex;

               $('.swiper-slide').attr('aria-hidden','true');

               setTimeout(function(){
                  $('.swiper-slide-active').attr('aria-hidden','false');
                  $("#SwiperLive").text("Slide "+(myslide +1) +" displayed");
               }, 0);
            },
          },
         keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          a11y: {
            containerRoleDescriptionMessage: 'Decorative slideshow',
            // slideLabelMessage: 'Slide number {{index}}',
            slideRole: 'listitem',
          },
      });

      $('.content-swiper-' + i ).each( function() {

         contentSwiper.loopDestroy();

         const typeChild = $(this).find('.swiper-slide'),
               typeWrapper = $(this).find('.swiper-wrapper');

         if ( typeChild.length > 1 ) {
            contentSwiper.loopCreate();

            var x = document.getElementsByClassName("content-slide");

            for(var i = 0; i < x.length; i++) {

               var el = x[i];

            var swiper = el.getElementsByClassName("swiper-container")[0];
            var nx = el.getElementsByClassName("swiper-next")[0];
            var pr = el.getElementsByClassName("swiper-prev")[0];

            new Swiper(swiper, {
                  slidesPerView: 2,
                  spaceBetween: 10,
                  navigation: {
                     nextEl: nx,
                     prevEl: pr
                  }
            });
            }

               // ===================================================
               // == Play / Pause button for slideshow
               //====================================================
                  var playPauseBtn = $('.swiper-navigation .playpause'),
                     swiperNav = $('.swiper-navigation div[role="button"]'),
                     // player = $('.feature-banner video').get(0),
                     icon = $('.swiper-navigation .playpause .fas');

                     // if ( contentSwiper.autoplay.paused ) {
                     //    console.log('stop');
                     //    playPauseBtn.attr( 'aria-pressed', 'true' );
                     //    icon.addClass('fa-play').removeClass('fa-pause');
                     // }

                  // add swiper id to button for aria labelling
                  if ( swiperNav.length ) {
                     var controlID = swiperNav.attr('aria-controls');
                     playPauseBtn.attr('aria-controls', controlID);
                  }

                  playPauseBtn.click( function(){

                     if ( !contentSwiper.autoplay.running ) {
                        contentSwiper.autoplay.start();
                        playPauseBtn.attr( 'aria-pressed', 'false' );
                        icon.addClass('fa-pause').removeClass('fa-play');
                     } else {
                        contentSwiper.autoplay.stop();
                        playPauseBtn.attr( 'aria-pressed', 'true' );
                        icon.addClass('fa-play').removeClass('fa-pause');
                     }
                  });

         } else {
            contentSwiper.autoplay.stop();

            // If .swiper-wrapper does not have "disabled" class, add it
            if ( !typeWrapper.hasClass("disabled") ) {
               typeWrapper.addClass( "disabled" );
            }
         }
      });

   }

       // ===================================================
   // == Content Carrousel  4 Col / Swiper Initialization
   //====================================================

   const thecolcontent = document.querySelectorAll('.col-content-swiper');
   for( let i = 0; i < thecolcontent.length; i++ ) {

      thecolcontent[i].classList.add('col-content-swiper-' + i);

      const colcontentSwiper = new Swiper('.col-content-swiper-' + i, {
         slidesPerView: 1,
         spaceBetween: 30,
         loop: true,         pagination: {
            el: ".swiper-pagination"
         },
        breakpoints: {
         640: {
           slidesPerView: 1,
           spaceBetween: 30,
         },
         667: {
           slidesPerView: 2,
           spaceBetween: 30,
         },
         1024: {
           slidesPerView: 3,
           spaceBetween: 30,
         },
         1150: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
       },
         navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          },
          runCallbacksOnInit:false,
          on: {
            init: function(swiper){
               $('.swiper-slide').attr('aria-hidden','true');
               $('.swiper-slide-active').attr('aria-hidden','false');
            },
            slideChange: function(swiper){
               var myslide = colcontentSwiper.activeIndex;

               $('.swiper-slide').attr('aria-hidden','true');

               setTimeout(function(){
                  $('.swiper-slide-active').attr('aria-hidden','false');
                  $("#SwiperLive").text("Slide "+(myslide +1) +" displayed");
               }, 0);
            },
          },
         keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          a11y: {
            containerRoleDescriptionMessage: 'Decorative slideshow',
            // slideLabelMessage: 'Slide number {{index}}',
            slideRole: 'listitem',
          },
      });

      $('.col-content-swiper' + i ).each( function() {

         colcontentSwiper.loopDestroy();

         const typeChild = $(this).find('.swiper-slide'),
               typeWrapper = $(this).find('.swiper-wrapper');

         if ( typeChild.length > 1 ) {
            colcontentSwiper.loopCreate();

            var x = document.getElementsByClassName("col-content-slide");

for(var i = 0; i < x.length; i++) {

	var el = x[i];

  var swiper = el.getElementsByClassName("swiper-container")[0];
  var nx = el.getElementsByClassName("swiper-next")[0];
  var pr = el.getElementsByClassName("swiper-prev")[0];

  new Swiper(swiper, {
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
          nextEl: nx,
          prevEl: pr
        }
  });
}

               // ===================================================
               // == Play / Pause button for slideshow
               //====================================================
                  var playPauseBtn = $('.swiper-navigation .playpause'),
                     swiperNav = $('.swiper-navigation div[role="button"]'),
                     // player = $('.feature-banner video').get(0),
                     icon = $('.swiper-navigation .playpause .fas');

                     // if ( colcontentSwiper.autoplay.paused ) {
                     //    console.log('stop');
                     //    playPauseBtn.attr( 'aria-pressed', 'true' );
                     //    icon.addClass('fa-play').removeClass('fa-pause');
                     // }

                  // add swiper id to button for aria labelling
                  if ( swiperNav.length ) {
                     var controlID = swiperNav.attr('aria-controls');
                     playPauseBtn.attr('aria-controls', controlID);
                  }

                  playPauseBtn.click( function(){

                     if ( !colcontentSwiper.autoplay.running ) {
                        colcontentSwiper.autoplay.start();
                        playPauseBtn.attr( 'aria-pressed', 'false' );
                        icon.addClass('fa-pause').removeClass('fa-play');
                     } else {
                        colcontentSwiper.autoplay.stop();
                        playPauseBtn.attr( 'aria-pressed', 'true' );
                        icon.addClass('fa-play').removeClass('fa-pause');
                     }
                  });

         } else {
            colcontentSwiper.autoplay.stop();

            // If .swiper-wrapper does not have "disabled" class, add it
            if ( !typeWrapper.hasClass("disabled") ) {
               typeWrapper.addClass( "disabled" );
            }
         }
      });
   }

   // requestGrantForm = document.getElementById('request-a-grant');

   // if ( requestGrantForm != null ) {

   //    const consultantReqs = document.querySelector('[data-id="consultant-reqs"]');
   //    const consultantForm = document.querySelector('[data-id="consultant"]');

   //    consultantReqs.addEventListener('change', e => {
   //       if ( $( '[data-id="consultant-reqs"] input[type="checkbox"]:checked' ).length === $('[data-id="consultant-reqs"] input[type="checkbox"]' ).length) {
   //          consultantForm.style.display = 'block';
   //          consultantForm.classList.remove('wpcf7cf-hidden');
   //       } else {
   //          consultantForm.style.display = 'none';
   //       }
   //    });
   // }

});
